export default __webpack_public_path__ + "static/weel-homepage-animation-8cd9ec9abaafd8cf330becac4a83579f.mp4";